import React, { useEffect, useState, useCallback } from "react";
import { FaSearch } from "react-icons/fa";
import "../FormsDetailsContent/FormsDetailsContent.css";
import "../../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faCircleArrowLeft,
  faCircleInfo,
  faPen
} from "@fortawesome/free-solid-svg-icons";

import ResponceDetails from "../ResponceDetails/ResponceDetails";
import EditResponseOffcanvas from "../EditResponse/EditResponse.jsx";

import { documentService, formService } from "../../../service";

const FormsDetailsContent = ({ onBack, formId }) => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

  const [documents, setDocuments] = useState([]);
  const [form, setForm] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [filterBy, setFilterBy] = useState("serial");

  // --------------------------------------------------------------------------
  // Fetching documents + form info
  // --------------------------------------------------------------------------
  const fetchData = useCallback(async () => {
    try {
      const { data: docs } = await documentService.getByForm(formId);
      setDocuments(docs);

      const { data: formData } = await formService.getById(formId);
      setForm(formData);
    } catch (err) {
      console.error("❌ Error fetching form documents:", err);
    }
  }, [formId]);

  useEffect(() => {
    if (formId) fetchData();
  }, [formId, fetchData]);

  // --------------------------------------------------------------------------
  // Reload after editing
  // --------------------------------------------------------------------------
  const reloadDocuments = useCallback(async () => {
    try {
      const { data: docs } = await documentService.getByForm(formId);
      setDocuments(docs);
    } catch (err) {
      console.error("Erreur reload:", err);
    }
  }, [formId]);

  // --------------------------------------------------------------------------
  // Filtering
  // --------------------------------------------------------------------------
  const filteredDocuments = documents.filter((doc) => {
    if (filterBy === "serial") {
      return doc.serial_number?.toLowerCase().includes(searchTerm.toLowerCase());
    }

    // Full name filter
    const fullName = `${doc.submitter.first_name} ${doc.submitter.last_name}`
      .trim()
      .toLowerCase();

    return fullName.includes(searchTerm.toLowerCase());
  });

  return (
    <div className="overflow-y-auto px-0" style={{ height: "100%" }}>
      <div className="container-fluid">

        {/* HEADER + SEARCH */}
        <div className="d-flex align-items-center gap-2">
          <div
            className="d-flex align-items-center back-arrow pb-3"
            onClick={onBack}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={faCircleArrowLeft} />
          </div>

          <div className="search-bar-details flex-grow-1 d-flex align-items-center justify-content-between">
            <div className="search-group">
              <input
                type="text"
                placeholder="Chercher un dossier..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <button className="icon-btn">
                <FaSearch />
              </button>
            </div>
            <div className="select-group">
              <select
                value={filterBy}
                onChange={(e) => setFilterBy(e.target.value)}
              >
                <option value="serial">Par Numéro de dossier</option>
                <option value="name">Par Nom d'auteur</option>
              </select>
            </div>
          </div>
        </div>

        {/* TITLE */}
        <div className="form-title-detail py-3  d-flex justify-content-center align-items-center mb-3">
          <h5 style={{ color: "black" }}>
            Titre de formulaire : {form?.title || "Aucun titre"}
          </h5>
        </div>

        {/* ACCORDION */}
        <div className="accordion mt-3" id="accordionPanelsStayOpenExample">
          {filteredDocuments.length === 0 ? (
            <p className="mt-4 text-center text-muted">Aucun document trouvé</p>
          ) : (
            filteredDocuments.map((doc, index) => {
              const entries = Object.entries(doc.values_json || {});
              const firstFive = entries.slice(0, 5);

              const fullName = `${doc.submitter.first_name} ${doc.submitter.last_name}`;

              return (
                <div className="accordion-item" key={doc.id}>
                  <h2 className="accordion-header">
                    <button
                      className={`accordion-button ${
                        index !== 0 ? "collapsed" : ""
                      }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#doc-collapse-${index}`}
                      aria-expanded={index === 0 ? "true" : "false"}
                      aria-controls={`doc-collapse-${index}`}
                    >
                      {doc.serial_number}
                    </button>
                  </h2>

                  <div
                    id={`doc-collapse-${index}`}
                    className={`accordion-collapse collapse ${
                      index === 0 ? "show" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <div className="row g-3">

                        {/* NOM & PRENOM */}
                        <div className="col-3">
                          <div className="forme-attr py-1 px-4 d-flex flex-column">
                            <span className="attr-label d-block">Nom & Prénom</span>
                            <div className="d-flex align-items-center">
                              <span
                                style={{
                                  fontWeight: 500,
                                  fontSize: "0.9rem",
                                }}
                              >
                                {fullName}
                              </span>
                              <FontAwesomeIcon icon={faUser} className="input-icon ms-auto" />
                            </div>
                          </div>
                        </div>

                        {/* FIRST 5 FIELDS */}
                        {firstFive.map(([key, value], i) => (
                          <div className="col-3" key={i}>
                            <div className="forme-attr py-1 px-4 d-flex flex-column">
                              <span className="attr-label d-block">{key}</span>
                              <span style={{ fontWeight: 500, fontSize: "0.9rem" }}>
                                {String(value)}
                              </span>
                            </div>
                          </div>
                        ))}

                        {/* BUTTONS */}
                        <div className="col-3 d-flex justify-content-end align-items-center gap-2">
                          <button
                            className="details-btn"
                            onClick={() => {
                              setSelectedDoc(doc);
                              setShowOffcanvas(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                            Details
                          </button>

                          <button
                            className="details-btn"
                            onClick={() => {
                              setSelectedDoc(doc);
                              setShowEdit(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} className="me-2" />
                            Modifier
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* DETAILS OFFCANVAS */}
      <ResponceDetails
        show={showOffcanvas}
        onClose={() => setShowOffcanvas(false)}
        documentData={selectedDoc}
      />

      {/* EDIT OFFCANVAS */}
      <EditResponseOffcanvas
        show={showEdit}
        onClose={() => setShowEdit(false)}
        form={form}
        documentData={selectedDoc}
        onUpdated={reloadDocuments}
      />
    </div>
  );
};

export default FormsDetailsContent;
